import { PlayerInformationCenterWidgetResponse } from "@api-types/platform";
import { UserTypes, getApplicationHeaders, httpClient } from "@utils";

export class PlayerInformationApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/player-information-center`;
	}

	static getRequestHeaders(activeUser = UserTypes.PRIMARY) {
		const appHeaders = getApplicationHeaders(activeUser);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static async getPlayerInformationCenterWidget(
		userType = UserTypes.PRIMARY
	): Promise<PlayerInformationCenterWidgetResponse> {
		return await httpClient.post(
			`${this.baseUrl}/widget`,
			null,
			this.getRequestHeaders(userType),
			{ responseType: "json" }
		);
	}
}
